<template>
<div>
  <b-navbar
    toggleable="lg"
    :style="{ 'background-color':bgColor}"
    sticky
    >
    <div
      class="d-none d-lg-inline-flex order-lg-1"
      style="height: 60px"
      >
      <div class="mt-auto">

	<b-link
	  to="/trinapp/files"
	  @click.native="scrollToTop()"
	  v-if="$route.path === '/trinapp' ||
		$route.path === '/trinapp/files'"
	  >
	  <b-img :src="require('../assets/trinity_app.png')" class="nav-icon" />
	</b-link>

	<b-link
	  to="/trinpod"
	  @click.native="scrollToTop()"
	  v-if="$route.path === '/trinpod'">
	  <b-img :src="require('../assets/trinity_secure.png')" class="nav-icon" />
	</b-link>

	<b-link
	  to="/logistics"
	  @click.native="scrollToTop()"
	  v-if="$route.path === '/logistics'"
	  >
	  <b-img :src="require('../assets/trinity_logistics.png')" class="nav-icon" />
	</b-link>

	<b-link
	  to="/property"
	  @click.native="scrollToTop()"
	  v-if="$route.path === '/property'">
	  <b-img :src="require('../assets/trinity_properties_hat.png')" class="nav-icon" />
	</b-link>

	<b-link
	  to="/construction"
	  @click.native="scrollToTop()"
	  v-if="$route.path === '/construction' ||
		$route.path === '/construction/trinapps' ||
		$route.path === '/construction/trinapps/trinapp' ||
		$route.path === '/construction/trinapps/trinapp/cde' ||
		$route.path === '/construction/trinapps/trinapp/cde/crosslink' ||
		$route.path === '/construction/trinpod/aconex' ||
		$route.path === '/construction/trinpod'">
	  <b-img
	    :src="require('../assets/trinity_construction.png')"
	    class="nav-icon"
	    />
	</b-link>

	
	<div class="d-inline-block trebuchet align-middle"
	     style="font-size: 1.5rem; font-weight: 500;"
	     v-if="level === '1'">
	  <span
	    class="neon-blue ml-2"	      
	    v-if="$route.path === '/trinapp' ||
		  $route.path === '/trinpod' ||
		  $route.path === '/property' ||
		  $route.path === '/logistics'"
	    >
	    {{ title }}
	  </span>

	  <span class="red ml-2"
		v-if="$route.path === '/construction'"
		>
	    {{ title }}
	  </span>
	</div>	
      </div>

      
      <div
	class="mb-auto trebuchet align-middle"
	style="font-size: 1.5rem; font-weight: 500;"
	v-if="level === '2' || level === '3' || level === '4' || level === '5' || level === '6'"
	>
	
	<div v-if="$route.path === '/trinapp/files'">
	  <b-link
	    to="/trinapp/files"
	    @click.native="scrollToTop()"
	    class="blue"
	    style="text-decoration: none;"
	    >
	    <b-img :src="require('../assets/trinapp_files.png')" class="nav-icon mb-auto" />
	    <span>{{ title }}</span>
	  </b-link>
	</div>
	
	<div v-if="$route.path === '/construction/trinapps' ||
		   $route.path === '/construction/trinapps/trinapp' ||
		   $route.path === '/construction/trinapps/trinapp/cde' ||
		   $route.path === '/construction/trinapps/trinapp/cde/crosslink'">
	  <b-link
	    to="/construction/trinapps"
	    @click.native="scrollToTop()"
	    class="red"
	    style="text-decoration: none;"
	    >
	    <b-img
	      :src="require('../assets/trinapp.png')"
	      class="nav-icon mb-auto"
	      />
	    <span v-if="level === '2'">{{ title }}</span>
	  </b-link>
	</div>
	
      </div>

      <div v-if="$route.path === '/construction/trinpod' ||
		 $route.path === '/construction/trinpod/aconex'"
	   >
	<b-link
	  to="/construction/trinpod"
	  @click.native="scrollToTop()"
	  class="red"
	  style="text-decoration: none;"
	  >
	  <b-img
	    :src="require('../assets/trinpod_secure.png')"
	    class="nav-icon mb-auto"
	    />
	  <span v-if="level === '2'">{{ title }}</span>
	</b-link>

      </div>     
      
      <div
	class="mt-auto trebuchet align-middle"
	style="font-size: 1.5rem; font-weight: 500;"
	v-if="level === '4' || level === '5' || level === '6'"
	>
	
	<div v-if="$route.path === '/construction/trinapps/trinapp' ||
		   $route.path === '/construction/trinapps/trinapp/cde' ||
		   $route.path === '/construction/trinapps/trinapp/cde/crosslink'">
	  <b-link
	    to="/construction/trinapps/trinapp/cde"
	    @click.native="scrollToTop()"
	    class="red"
	    style="text-decoration: none;"
	    >
	    <b-img :src="require('../assets/trinapp_cde.png')" class="nav-icon mb-auto" />
	    <span v-if="level === '4'">{{ title }}</span>
	  </b-link>
	</div>
	
      </div>

      <div
	class="mt-auto trebuchet align-middle"
	style="font-size: 1.5rem; font-weight: 500;"
	v-if="level === '4'"
	>
	
	<div v-if="$route.path === '/construction/trinpod' ||
		   $route.path === '/construction/trinpod/aconex'">
	  <b-link
	    to="/construction/trinpod/aconex"
	    @click.native="scrollToTop()"
	    class="red" style="text-decoration: none;"
	    >
	    <b-img :src="require('../assets/trinapp-aconex.png')" class="nav-icon mb-auto" />
	    <span v-if="level === '4'">{{ title }}</span>
	  </b-link>
	</div>
	
      </div>


      <div
	class="mb-auto trebuchet align-middle"
	style="font-size: 1.5rem; font-weight: 500;"
	v-if="level === '5' || level === '6'"
	>
	
	<div v-if="$route.path === '/construction/trinapps/trinapp' ||
		   $route.path === '/construction/trinapps/trinapp/cde' ||
		   $route.path === '/construction/trinapps/trinapp/cde/crosslink'">
	  <b-link
	    to="/construction/trinapps/trinapp/cde/crosslink"
	    @click.native="scrollToTop()"
	    class="red" style="text-decoration: none;"
	    >
	    <b-img :src="require('../assets/trinapp_crosslink.png')" class="nav-icon mb-auto" />
	    <span v-if="level === '5'">{{ title }}</span>
	  </b-link>
	</div>
	
      </div>
      
    </div>


    <b-navbar-toggle target="nav-collapse" class="order-2"></b-navbar-toggle>


    <b-collapse id="nav-collapse" is-nav class="order-last order-lg-3">
      <b-navbar-nav
	class="mx-auto"
	v-if="$route.path === '/trinapp' ||
	      $route.path === '/trinapp/files' ||
	      $route.path === '/trinpod'"
	>
	
	<b-nav-item
	  class="pr-0"
	  style="min-width: 100px;"
	  href="https://trinpod.us/pricing?industry=productivity"
	  >
	  <span v-if="pricing === 'true'">
	    Pricing
	  </span>
	</b-nav-item>
      

	<div
	  @mouseover="dropdownShow('trinapps-dropdown')"
	  @mouseleave="dropdownHide('trinapps-dropdown')"
	  >
	  <b-nav-item-dropdown
	    id="trinapps-dropdown"
	    text="TrinApps"
	    class="pr-0"
	    style="min-width: 100px;"
	    >
	    <b-dropdown-item
	      class="pl-3"
	      to="/trinapp"
	      @click.native="scrollToTop()"
	      >
	      LaunchPad
	    </b-dropdown-item>
	    <b-dropdown-item
	      class="pl-3"
	      to="/trinapp/files"
	      @click.native="scrollToTop()"
	      >
	      Files
	    </b-dropdown-item>
	  </b-nav-item-dropdown>
	</div>
      
	<div
	  @mouseover="dropdownShow('trinpod-dropdown')"
	  @mouseleave="dropdownHide('trinpod-dropdown')"
	  >
	  <b-nav-item-dropdown
	    id="trinpod-dropdown"
	    text="TrinPod"
	    class="pr-0"
	    style="min-width: 100px;"
	    >
            <b-dropdown-item
	      class="pl-2"
	      to="/trinpod"
	      @click.native="scrollToTop()"
	      >
	      TrinPod
	    </b-dropdown-item>
	  </b-nav-item-dropdown>
	</div>
      </b-navbar-nav>
   
       

      <b-navbar-nav
	class="mx-auto"
	v-if="$route.path === '/construction' ||
	      $route.path === '/construction/trinapps' ||
	      $route.path === '/construction/trinapps/trinapp' ||
	      $route.path === '/construction/trinapps/trinapp/cde' ||
	      $route.path === '/construction/trinapps/trinapp/cde/crosslink' ||
	      $route.path === '/construction/trinpod/aconex' ||
	      $route.path === '/construction/trinpod'"
	>
	
	<b-nav-item
	  class="pr-0"
	  style="min-width: 100px;"
	  href="https://trinpod.us/pricing?industry=construction"
	  >
	  <span v-if="pricing === 'true'">Pricing</span>
	</b-nav-item>
	
	<div
	  @mouseover="dropdownShow('trinapps-dropdown')"
	  @mouseleave="dropdownHide('trinapps-dropdown')"
	  >
	  <b-nav-item-dropdown
	    id="trinapps-dropdown"
	    text="TrinApps"
	    class="pr-2"
	    style="min-width: 100px;"
	    >
	    <b-dropdown-item
	      class="pl-2"
	      to="/construction/trinapps"
	      @click.native="scrollToTop()"
	      >
	      TrinApps
	    </b-dropdown-item>
	    <b-dropdown-item
	      class="pl-2"
	      to="/construction/trinapps/trinapp"
	      @click.native="scrollToTop()"
	      >
	      LaunchPad
	    </b-dropdown-item>
	    <b-dropdown-item
	      class="pl-2"
	      to="/construction/trinapps/trinapp/cde"
	      @click.native="scrollToTop()"
	      >
	      CDE
	    </b-dropdown-item>
	    <b-dropdown-item
	      class="pl-2"
	      to="/construction/trinapps/trinapp/cde/crosslink"
	      @click.native="scrollToTop()"
	      >
	      Crosslink
	    </b-dropdown-item>	    
	  </b-nav-item-dropdown>
	</div>
      
	<div
	  @mouseover="dropdownShow('trinpod-dropdown')"
	  @mouseleave="dropdownHide('trinpod-dropdown')"
	  >
	  <b-nav-item-dropdown
	    id="trinpod-dropdown"
	    text="TrinPod"
	    class="pr-0"
	    style="min-width: 100px;"
	    ref="dropdown"
	    >
	    <b-dropdown-item
	      class="pl-2"
	      to="/construction/trinpod"
	      @click.native="scrollToTop()"
	      >
	      TrinPod
	    </b-dropdown-item>
	    <b-dropdown-header
	      class="pl-2 text-secondary"
	      >
	      TrinPod Links
	    </b-dropdown-header>
	    <b-dropdown-item
	      class="pl-3"
	      to="/construction/trinpod/aconex"
	      @click.native="scrollToTop()"
	      >
	      Oracle aconex Link
	    </b-dropdown-item>
	  </b-nav-item-dropdown>
	</div>
	<b-dropdown-divider />
      </b-navbar-nav>

      <b-button
	class="bg-transparent 
	       px-3 
	       d-inline-block 
	       d-lg-none"
	>
	<b-link
	  href="https://graphmetrix.net/"
	  target="_blank"
	  class="btn-trinapp"
	  >
	  LaunchPad
	  <font-awesome-icon
	    :icon="faSignInAlt"
	    class="d-inline-block"
	    />
	</b-link>
      </b-button>
            
    </b-collapse>

    
      
    <b-button
      class="btn-neon-blue ml-sm-auto order-sm-4 order-5 banner-btn px-2 px-sm-5"
      v-if="$route.path === '/trinapp' ||
	    $route.path === '/trinapp/files' || 
	    $route.path === '/trinpod'"
      href="https://forms.zohopublic.com/graphmetrix/form/TrinAppProjectsEarlyAccessWaitList/formperma/uQZjDY2CZjT85rjwA0I1NmTa4-ueyTaba42g4DsE6sk"
      
      >
      Get Started
    </b-button>
    
    <b-button
      class="btn-orange ml-sm-auto order-sm-4 order-5 banner-btn px-2 px-sm-5"
      v-if="$route.path === '/' ||
            $route.path === '/construction' ||
	    $route.path === '/construction/trinapps' ||
	    $route.path === '/construction/trinapps/trinapp' ||
	    $route.path === '/construction/trinapps/trinapp/cde' ||
	    $route.path === '/construction/trinapps/trinapp/cde/crosslink' ||
	    $route.path === '/construction/trinpod/aconex' ||
	    $route.path === '/construction/trinpod'"
      href="https://forms.zohopublic.com/graphmetrix/form/TrinAppProjectsEarlyAccessWaitList/formperma/uQZjDY2CZjT85rjwA0I1NmTa4-ueyTaba42g4DsE6sk"
      
      >
      Get Started
    </b-button>
    
    <b-button
      class="btn-neon-blue ml-sm-auto order-sm-4 order-5 banner-btn px-2 px-sm-5"
      v-if="title === 'Property'"
      href="https://forms.zohopublic.com/graphmetrix/form/RequestCallbackregardingTrinityProperty/formperma/lDiSlWacpjS1U9urdnU0uX3VRKaLcQapRH0xZ2P_j1Q"
      target="_blank"
      >
      Request Meeting
    </b-button>
    
    <b-button
      class="btn-neon-blue ml-sm-auto order-sm-4 order-5 banner-btn px-2 px-sm-5"
      v-if="title === 'Logistics'"
      href="https://forms.zohopublic.com/graphmetrix/form/Logistics/formperma/awDNUrpCkZkWr0X4lB-a6RsMzrbwTRuz3JUlFeDBVTU"
      target="_blank"
      >
      Request Meeting
    </b-button>

  
    <b-dropdown
      class="btn-mega-menu px-1 mx-auto mx-sm-0 order-4 order-sm-5"
      no-caret
      >
      <template slot="button-content">
	<b-img
	:src="require('../assets/gmx_logo.png')"
	style="height: 2.5rem;"
	class="btn-gmx-img"
	/>
      </template>
      <b-dropdown-item>
	<GmxFooter
	  class="bg-light p-0"
	  link-class="font-weight-bold text-dark"
	  p-class="text-dark"
	  />
      </b-dropdown-item>
    </b-dropdown>
   
    <b-button
      class="bg-transparent 
	     px-1 
	     border-0
	     d-none
	     d-lg-inline-block
	     order-6">
      <b-link
	href="https://forms.zohopublic.com/graphmetrix/form/TrinAppProjectsEarlyAccessWaitList/formperma/uQZjDY2CZjT85rjwA0I1NmTa4-ueyTaba42g4DsE6sk"
	target="_blank"
	class="btn-trinapp">
	LaunchPad
	<font-awesome-icon
	  :icon="faSignInAlt"
	  class="d-inline-block"/>
      </b-link>
    </b-button>
    
  </b-navbar>
  
<b-container
  style="position: fixed; opacity: 0.95; z-index: 2;"
  fluid
  v-if="logoClick"
  >
    <GmxFooter
      class="bg-light"
      link-class="font-weight-bold text-dark"
      p-class="text-dark"
      />
  </b-container>
</div>
</template>

<script>
const $ = require('jquery')
import { vueWindowSizeMixin } from "vue-window-size";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'
import GmxFooter from '@/components/footer.vue'
import u from '@/util'
import * as log from 'loglevel'
export default {
    name: "Banner",
    props: {
	title: String,
	level: String,
	pricing: String,
	bgColor: String
    },
    components: {
	FontAwesomeIcon,
	GmxFooter
    },
    mixins: [vueWindowSizeMixin],
    data () {
	return {
	    faSignInAlt,
	    logoClick: false
	}
    },
    methods: {
	dropdownShow: function (id) {
	    if (this.windowWidth > 991) {
		$("#" + id + " .dropdown-menu").addClass("show")
	    }
	},
	dropdownHide: function (id) {
	    if (this.windowWidth > 991) {
		$("#" + id + " .dropdown-menu").removeClass("show")
	    }
	},
	/*onOver: function () {
            this.$refs.dropdown.visible = true;
	},
	onLeave: function () {
            this.$refs.dropdown.visible = false;
	},*/
	/*toggleFooter: function () {
	    var qObj = this.$route.query
	    if (qObj !== 'show-footer') {
		this.$router.push({ query: { 'show-footer': 'true' } })
	    } else if (qObj === 'show-footer') {
		log.debug('show-footer', qObj)
		this.$router.replace({ 'query': null })
	    }
	}*/
	scrollToTop: function () {
	    window.scrollTo(0,0);
	}
    }
    /*to put back on get started buttons
 href="https://trinpod.us/pricing?industry=productivity"
href="https://trinpod.us/pricing?industry=construction"

href="https://trinpod.us/"
*/
}
</script>

<style>
.trebuchet {
    font-family: Trebuchet MS, Helvetica, sans-serif;
}
.navbar-logo {
	width: 220px;
}
.btn-gmx-logo {
    background-color: transparent !important;
    border: 1px solid transparent !important;
}
.btn-gmx-logo:hover {
    border: 1px solid #ffb300 !important;
}
.btn-trinapp {    
    color: #656565;
}
.btn-trinapp:hover {
    color: #bababa;
    text-decoration: none;
}
.nav-icon {
    height: 40px;
}
.nav-link {
    padding-bottom: 0px !important;
}
.dropdown-menu {
    margin-top: 0px !important;
}
.btn-mega-menu > button {
    background-color: transparent !important;
    border: 0px;
    padding: 0px !important;
}
.btn-mega-menu > .dropdown-menu {
    position: fixed !important;
    transform: none !important;
    top: 75px !important;
    width: 100vw;
    padding: 0px;
    opacity: 0.95;
}
.btn-mega-menu > .dropdown-menu > .dropdown-item {
    padding: 0px;
}
@media (max-width: 575px) {
    /*.banner-btn {
	width: 136px;
	padding: 8px 0px !important;
    }*/
    .btn-gmx-img {
	height: 1.75rem !important;
    }
    .btn-mega-menu > .dropdown-menu {
	/*top: 57px !important;*/
	top: -235px !important;
	transform: scale(0.5) !important;
    }
}
</style>
